import { Injectable } from '@angular/core';
import { AppService } from '../../../../../core/service/Base.Service';
import { DataTransferObject } from '../../../../../core/entities/DataTransferObject';

@Injectable()
export class EmployeeinfohdrService extends AppService<any> {

    constructor() {
        super('Employeeinfohdr');
    }

    async getEmployee(clientid, entityid, employeecategory) {
        const data = await this.get('Employeeinfohdr', [clientid, entityid, employeecategory]);
        return data;
    }

    async GetCategoryWiseEmployee(employeecategory) {
        let entityid = this.localStorage.get("selectedEntity");
        const data = await this.get('CategoryWiseEmployee', [entityid, employeecategory]);
        return data;
    }

    async GetEmployeeEntity(entityid) {
        const data = await this.get('EmployeeEntity', entityid);
        return data;
    }

    async GetClientEmployees() {
        const data = await this.get('ClientEmployees');
        return data;
    }

    async GetEntityEmployee() {
        let entityid = this.localStorage.get('selectedEntity');
        const data = await this.get('EmployeeEntity', [entityid]);
        return data;
    }

    async GetEntityEmployeeV4() {
        let entityid = this.localStorage.get('selectedEntity');
        const data = await this.get('EntityEmployeeV4', [entityid]);
        return data;
    }

    async GetEmployeEntity() {
        let entityid = this.localStorage.get("selectedEntity");
        const data = await this.get('EmployeeEntity', [entityid]);
        return data;
    }

    async GetEmployeesListType(entityid, employeecategory) {
        const dto = await this.get('EmployeesListType', [entityid, employeecategory]);
        return dto;
    }

    async GetEmployeeListbycategory(entityid) {
        const dto = await this.get('EmployeeListbycategory', [entityid]);
        return dto;
    }

    async getemployeeComponent(employeeid) {
        const data = await this.get('EmployeeComponenet', employeeid);
        return data;
    }


    async getEmployeeList(entityid, Id) {
        const result = await this.get('Employee_Detail', [entityid, Id]);
        return result;
    }

    async getLoginUserInfo(Id) {

        const result = await this.get('LoginTeacherInfo', [Id]);

        return result;
    }
    async getEmployeeData(employeecode) {
        let refentityid = this.localStorage.get("selectedEntity");
        const result = await this.get('EmployeeData', [refentityid, 'null', employeecode]);
        return result;
    }

    async getEmployeeInfoList(entityid, employeeno, name, depid, desigid, employeetypeid, genderid,maritialid) {

        let refentityid = (entityid == undefined || entityid == 0 || entityid == "") ? this.localStorage.get("selectedEntity") : entityid;
        let refemployeeno = (employeeno == "" || employeeno == undefined) ? 'null' : employeeno;
        let refname = (name == undefined || name == 0 || name == "") ? 'null' : name;
        let refdepid = (depid == undefined || depid == 0 || depid == "") ? 'null' : depid;
        let refdesigid = (desigid == undefined || desigid == 0 || desigid == "") ? 'null' : desigid;
        let refemployeetypeid = (employeetypeid == undefined || employeetypeid == 0 || employeetypeid == "") ? 'null' : employeetypeid;
        let refgenderid = (genderid == undefined || genderid == 0 || genderid == "") ? 'null' : genderid;
        let refmaritialid = (maritialid == undefined ||maritialid == 0 || maritialid == "") ? 'null' : maritialid;


        const result = await this.get('EmployeeList', [refentityid, refemployeeno, refname, refdepid, refdesigid, refemployeetypeid, refgenderid]);
        return result;
    }

    async getHeadOfficeEmployee() {
        const result = await this.get('HeadOfficeEmployee');
        return result;
    }

    async getEmployeeBirthdays() {
        let entityid = Number(this.localStorage.get("selectedEntity"));
        const result = await this.get('EmployeeBirthdays', [entityid]);
        return result;
    }

    async GetEntityagainstEmployees() {
        let entityid = this.localStorage.get("selectedEntity");
        const data = await this.get('EntityagainstEmployees', [entityid]);
        return data;
    }

    async GetAdminEmployees() {
        let entityid = this.localStorage.get("selectedEntity");
        const data = await this.get('AdminEmployees', [entityid]);
        return data;
    }
    async getCourseagainstEmployee(courseid, sectionid) {
        let entityid = this.localStorage.get("selectedEntity");
        const data = await this.get('CourseAgainstTeacher', [entityid, courseid, sectionid]);
        return data;
    }

    async getTeacherSubjectPerformance(teacherid) {
        let entityid = this.localStorage.get("selectedEntity");
        const result = await this.get('TeacherSubjectPerformance', [entityid, teacherid]);
        return result;
    }

    async GetEmployeeSybjectRatingList(entityid) {
        const dto = await this.get('EmployeeSybjectRatingList', [entityid])
        return dto;
    }

    async getTeacherSubjects(Id) {
        const result = await this.get('TeacherSubjects', [Id]);
        return result;
    }

    async bulkemployeesaving(Data){
        const _data = <DataTransferObject<any>>{
            Data: Data,
        };
         
        const result = await this.post('Bulkemployeesaving',_data);
        return result;
    }

async GetLeavegroupEmployee(leavegrpid) {
        let entityid = this.localStorage.get("selectedEntity");
        const result = await this.get('LeavegroupEmployee', [entityid, leavegrpid]);
        return result;
    }


    async getDriver(entityid, employeecategory) {
        const result = await this.get('EmployeesListType', [entityid, employeecategory])
        return result
    }

    async getConductor(entityid, employeecategory) {
        const result = await this.get('EmployeesListType', [entityid, employeecategory])
        return result

    }

}


// WEBPACK FOOTER //
// ./src/app/shell/forms/Employee-Profile/Employeeinfohdr/employee-profile/employee-profile.service.ts